import { CargoStoreList } from '../models';

const getIsEnabledHeaderBtn = (stores: CargoStoreList) =>
  stores.some(s => s.isEnabled);

export const cargoUIHelper = {
  getIsEnabledHeaderBtn,
} as const;
